// Subscription Tiers Constants
export const TIERS = {
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold'
};

// Quotas per subscription tier
export const QUOTAS = {
  [TIERS.BRONZE]: {
    auditors: 3,
    templateClones: 1,
    delegateAdmins: 0,
    customChapters: 0
  },
  [TIERS.SILVER]: {
    auditors: 10,
    templateClones: 3,
    delegateAdmins: 1,
    customChapters: 0
  },
  [TIERS.GOLD]: {
    auditors: 50,
    templateClones: 15, // Total templates limit (including custom & cloned)
    delegateAdmins: 5,
    customChapters: 50
  }
};

/**
 * Normalizes subscription string to one of the defined TIERS.
 * Defaults to BRONZE if unrecognized.
 */
export const getSubscriptionTier = (subscription) => {
  const normalized = String(subscription || '').toLowerCase();
  if (normalized === 'silver') return TIERS.SILVER;
  if (normalized === 'gold') return TIERS.GOLD;
  return TIERS.BRONZE; // Maps both "Basic" and "Bronze" to Tier 1
};

// Check functions for feature access
export const canCreateTemplate = (tier) => tier === TIERS.GOLD;
export const canEditTemplate = (tier) => tier === TIERS.GOLD;
export const canManageChapters = (tier) => tier === TIERS.GOLD;
export const canExportCSV = (tier) => tier === TIERS.GOLD;
export const canUseAdvancedFilters = (tier) => tier === TIERS.GOLD;

// Limit helpers
export const getAuditorsLimit = (tier) => QUOTAS[tier]?.auditors || 3;
export const getTemplateClonesLimit = (tier) => QUOTAS[tier]?.templateClones || 1;
export const getDelegateAdminsLimit = (tier) => QUOTAS[tier]?.delegateAdmins || 0;
export const getCustomChaptersLimit = (tier) => QUOTAS[tier]?.customChapters || 0;
